<script>
	export default {
		onLaunch: function() {},
		onShow: function() {},
		onHide: function() {}
	};
</script>

<style lang="scss">
	/*每个页面公共css */
	@import '@/uni_modules/uv-ui-tools/index.scss';
	@import '@/static/index.css';

	page {
		background-color: #1B1F30;
	}

	.empty {
		display: flex;
		justify-content: center;
		padding: 120rpx 0 20rpx 0;

		.image {
			width: 300rpx;
			height: 300rpx;
			display: block;
		}
	}

	.box {
		background-color: #1B1F30;
		min-height: calc(100vh - 44px - env(safe-area-inset-top));
	}

	.hengColor {
		color: #002288;
	}

	:deep(.uv-loadmore) {
		margin: 0 !important;
		padding: 30rpx 0;
	}

	:deep(.input-placeholder) {
		color: #999999 !important;
		font-size: 28rpx;
	}

	:deep(.uv-input__content__prefix-icon) {
		margin-right: 0 !important;
	}
</style>